var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullstoryIcon = function SvgFullstoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16317_35184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8789 15.3734V13.738H13.0732L18.9338 10.378L18.9681 10.3585L18.1486 8.94368L12.2532 12.3231L15.6366 6.50254L15.6566 6.46825L14.2521 5.66254L14.2326 5.65111L10.8292 11.5054V4.74768H9.18748V11.5123L5.8052 5.68997L5.78577 5.65568L4.38063 6.46139L4.36063 6.47339L7.76405 12.3283L1.90291 8.96825L1.86863 8.94882L1.04977 10.3637L6.94405 13.7431H0.140625V15.3745H6.27777C8.01491 15.1945 8.94863 14.2277 9.42634 13.4465C9.69896 12.9963 9.89658 12.5048 10.0115 11.9911C10.0772 12.2905 10.2389 12.8597 10.5972 13.4465C11.0749 14.226 12.0081 15.1934 13.7498 15.3745H19.8789V15.3734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8789 15.3734V13.738H13.0732L18.9338 10.378L18.9681 10.3585L18.1486 8.94368L12.2532 12.3231L15.6366 6.50254L15.6566 6.46825L14.2521 5.66254L14.2326 5.65111L10.8292 11.5054V4.74768H9.18748V11.5123L5.8052 5.68997L5.78577 5.65568L4.38063 6.46139L4.36063 6.47339L7.76405 12.3283L1.90291 8.96825L1.86863 8.94882L1.04977 10.3637L6.94405 13.7431H0.140625V15.3745H6.27777C8.01491 15.1945 8.94863 14.2277 9.42634 13.4465C9.69896 12.9963 9.89658 12.5048 10.0115 11.9911C10.0772 12.2905 10.2389 12.8597 10.5972 13.4465C11.0749 14.226 12.0081 15.1934 13.7498 15.3745H19.8789V15.3734Z",
    fill: "#07C799"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16317_35184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 10.8571,
    fill: "white",
    transform: "translate(0.140625 4.56995)"
  })))));
};
export { SvgFullstoryIcon as ReactComponent };
export default __webpack_public_path__ + "fullstory-icon.svg";